export default "__VITE_ASSET__58452df4__"